import React, { useContext } from 'react';
import { Picture, Img, Source } from '@xo-union/tk-component-picture';
import ThemeContext from '../../../helpers/ThemeContext';
import styles from './index.scss';

const Preview: React.FC = () => {
  const { currentColorway } = useContext(ThemeContext);

  return (
    <div className={`${styles.imageContainer}`}>
      <div className={styles.desktop}>
        <Picture id={currentColorway?.previewImage?.mediaApiId} className={styles.desktopImage} pixelDensities={[1]}>
          <Source viewport="md" width={300} height={225} pixelDensity={1} />
          <Source viewport="lg" width={600} height={450} pixelDensity={1} />
          <Source viewport="xl" width={1200} height={900} pixelDensity={1} />
          <Source viewport="md" width={250} height={187.5} pixelDensity={2} />
          <Source viewport="xl" width={400} height={300} pixelDensity={2} />
          <Img
            key={currentColorway?.previewImage?.mediaApiId}
            width={1000}
            alt={`Previewing design ${currentColorway?.name}.`}
            className={styles.image}
          />
        </Picture>
      </div>
      <div className={styles.mobile}>
        <Picture
          id={currentColorway?.mobilePreviewImage?.mediaApiId}
          className={styles.mobileImage}
          pixelDensities={[1]}
        >
          <Source viewport="md" width={200} height={432} pixelDensity={1} />
          <Source viewport="lg" width={300} height={649} pixelDensity={1} />
          <Source viewport="xl" width={500} height={1082} pixelDensity={1} />
          <Source viewport="md" width={125} height={324.5} pixelDensity={2} />
          <Source viewport="xl" width={250} height={541} pixelDensity={2} />
          <Img
            key={currentColorway?.mobilePreviewImage?.mediaApiId}
            width={300}
            alt={`Previewing design ${currentColorway?.name}.`}
            className={styles.image}
          />
        </Picture>
      </div>
    </div>
  );
};

export default Preview;
